import React from 'react';
import {
  BadgesContainer,
  CardProducElement,
  CardProductDetail,
  CardProductImage,
  CardProductPriceCta,
} from './CardProductVertical.styles';
import CardImage from '@/components/card/CardImage/CardImage';
import { Text, Title } from '@/components/typography';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import Badge from '@/components/badge/Badge';
import { DefaultTheme } from 'styled-components';
import TravelDetailList from '@/features/pacote/components/TravelDetailList/TravelDetailList';

export interface CardProductProps {
  pacote: PacoteType;
  className?: string;
}

const CardProductVertical = ({ pacote, ...props }: CardProductProps) => {
  const {
    id,
    title,
    permalink,
    image,
    travel_type,
    travel_city,
    travel_amount,
    travel_currency,
    travel_flight,
    travel_amount_info,
    travel_duration,
    travel_depart,
    travel_meal,
    expired_at,
    ribbon,
  } = pacote;

  // let ribbon = null;
  // ribbon = 'OFERTA';
  // ribbon = 'COM AÉREO';
  // ribbon = 'EXCLUSIVO';
  // ribbon = 'NOVO';

  let badgeColor: keyof DefaultTheme['color'] & string;
  switch (ribbon) {
    case 'OFERTA':
      badgeColor = 'destructive_500';
      break;
    case 'COM AÉREO':
      badgeColor = 'dark';
      break;
    case 'EXCLUSIVO':
      badgeColor = 'success_500';
      break;
    default:
    case 'NOVO':
      badgeColor = 'white';
      break;
  }

  return (
    <CardProducElement>
      <CardProductImage>
        <CardImage image={image} href={permalink} minHeight={244} minHeightMobile={213.5} />
        {(ribbon && (
          <BadgesContainer>
            <Badge color={badgeColor} size="sm">
              {ribbon}
            </Badge>
          </BadgesContainer>
        )) ||
          null}
      </CardProductImage>
      <CardProductDetail>
        <Link href={permalink}>
          <Title as="h3" size="lg">
            Pacote {title}
          </Title>
        </Link>
        <TravelDetailList
          travel_type={travel_type}
          travel_city={travel_city}
          travel_duration={travel_duration}
          travel_depart={travel_depart}
          travel_flight={travel_flight}
          travel_meal={travel_meal}
          expired_at={expired_at}
        />
      </CardProductDetail>
      <CardProductPriceCta>
        <Text as="span" textCase="uppercase" weight="light">
          preço a partir
        </Text>
        <div>
          <Text as="span" size="xl" weight="bold">
            {(!travel_amount && (
              <Text as="small" size="md">
                Consulte-nos
              </Text>
            )) || (
              <>
                <Text as="small" size="md">
                  {travel_currency}
                </Text>{' '}
                {travel_amount}
                {(travel_currency !== 'BRL' && <sup>*</sup>) || null}
              </>
            )}
          </Text>
          {(travel_amount && (
            <Text size="xs" as="small" textCase="uppercase">
              {travel_amount_info}
            </Text>
          )) ||
            null}
        </div>
        <Button href={permalink} block arrow appearance="outline">
          VEJA O ROTEIRO
        </Button>
      </CardProductPriceCta>
    </CardProducElement>
  );
};

export default CardProductVertical;
